// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1-DQ_","name":"styles_name__2d7Xz","phone":"styles_phone__350S3"};